import { render, staticRenderFns } from "./GovernmentPanel.vue?vue&type=template&id=9659c14c&"
import script from "./GovernmentPanel.vue?vue&type=script&lang=js&"
export * from "./GovernmentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports